/* ================= KONNI39 - GOP / THONG KE / DON =================
   buildDataset, summarize, initWorking, buildTrackingIndex: tach nguyen ven
   tu khoi window.KONNI cua app v4.
   mergeDataset, purgeOld: tach tu mergeRun()/purgeOld() cua app v4 thanh
   ham THUAN (khong ghi file, khong dung bien toan cuc) de test duoc va
   de doi tang luu tru (JSON -> Postgres) ma khong dung logic.
   Quy tac chi tiet: docs/01-DU-LIEU.md muc 5 va 6.
=================================================================== */
import { dayMs } from './text.js';
import { statusGroup } from './rules.js';

export const PURGE_DAYS = 10;

/* ---------- gop nhieu file -> dataset goc ---------- */
export function buildDataset(parsedFiles) {
  var orders = {};
  var duplicates = [];
  var unknownStatuses = {};
  var noBarcode = [];
  var files = [];

  // file cu xu ly truoc, file moi ghi de -> giu ban moi nhat
  var list = parsedFiles.slice().sort(function (a, b) {
    return (a.lastModified || 0) - (b.lastModified || 0);
  });

  list.forEach(function (pf) {
    var local = {};
    pf.rows.forEach(function (row) {
      var key = row.channel + '|' + row.orderId;
      if (!local[key]) {
        local[key] = {
          key: key,
          channel: row.channel,
          orderId: row.orderId,
          tracking: row.tracking,
          carrier: row.carrier,
          statusRaw: row.statusRaw,
          subStatus: row.subStatus,
          statusGroup: statusGroup(row.channel, row.statusRaw, row.subStatus),
          isReturn: !!row.returnStatus,
          orderDate: row.orderDate,
          sourceFile: pf.fileName,
          items: []
        };
        if (local[key].statusGroup === 'KHAC') {
          var kk = row.channel + ' · ' + (row.statusRaw || '(trống)');
          unknownStatuses[kk] = (unknownStatuses[kk] || 0) + 1;
        }
      }
      var o = local[key];
      if (!o.tracking && row.tracking) o.tracking = row.tracking;
      if (row.returnStatus) o.isReturn = true;

      var found = null;
      for (var i = 0; i < o.items.length; i++) {
        if (o.items[i].barcode === row.barcode) { found = o.items[i]; break; }
      }
      if (found) {
        found.qty += row.qty;
      } else {
        o.items.push({
          barcode: row.barcode,
          name: row.name,
          nameFull: row.nameFull,
          variation: row.variation,
          qty: row.qty
        });
      }
      if (!row.barcode) {
        noBarcode.push({ key: key, orderId: row.orderId, channel: row.channel, name: row.name });
      }
    });

    var nOrders = 0;
    Object.keys(local).forEach(function (k) {
      nOrders++;
      if (orders[k]) {
        duplicates.push({
          key: k,
          channel: local[k].channel,
          orderId: local[k].orderId,
          giuFile: pf.fileName,
          boFile: orders[k].sourceFile
        });
      }
      orders[k] = local[k];
    });

    files.push({
      fileName: pf.fileName,
      channel: pf.channel,
      sheet: pf.sheet,
      rows: pf.rows.length,
      orders: nOrders,
      lastModified: pf.lastModified || 0,
      notes: pf.notes
    });
  });

  return {
    orders: orders,
    files: files,
    duplicates: duplicates,
    unknownStatuses: unknownStatuses,
    noBarcode: noBarcode
  };
}

/* ---------- thong ke ---------- */
export function summarize(orders) {
  var s = {
    total: 0,
    byChannel: { SHOPEE: 0, TIKTOK: 0 },
    byGroup: { MOI: 0, CAN_GIAO: 0, XONG: 0, HUY: 0, KHAC: 0 },
    matrix: {},
    canGiao: 0,
    moiThieuMVD: 0,
    returnFlag: 0,
    items: 0,
    units: 0,
    noTracking: 0
  };
  Object.keys(orders).forEach(function (k) {
    var o = orders[k];
    s.total++;
    s.byChannel[o.channel] = (s.byChannel[o.channel] || 0) + 1;
    s.byGroup[o.statusGroup] = (s.byGroup[o.statusGroup] || 0) + 1;
    var mk = o.channel + '|' + o.statusGroup;
    s.matrix[mk] = (s.matrix[mk] || 0) + 1;
    if (o.statusGroup === 'CAN_GIAO') s.canGiao++;
    if (o.statusGroup === 'MOI' && !o.tracking) s.moiThieuMVD++;
    if (o.isReturn) s.returnFlag++;
    if (!o.tracking) s.noTracking++;
    s.items += o.items.length;
    o.items.forEach(function (it) { s.units += it.qty; });
  });
  return s;
}

/* ---------- trang thai lam viec ---------- */
export function freshWork(o) {
  return {
    pickState: 'pending', pickedAt: null, outState: 'pending', outAt: null, note: '',
    items: o.items.map(function (it) { return { barcode: it.barcode, picked: 0, isSub: false, name: null }; })
  };
}

export function initWorking(dataset, sessionId) {
  var w = { version: 1, session: sessionId, createdAt: new Date().toISOString(), updatedAt: null, orders: {}, log: [] };
  Object.keys(dataset.orders).forEach(function (k) {
    w.orders[k] = freshWork(dataset.orders[k]);
  });
  return w;
}

export function buildTrackingIndex(orders) {
  var idx = {};
  Object.keys(orders).forEach(function (k) {
    var t = orders[k].tracking;
    if (!t) return;
    var key = t.toUpperCase();
    if (!idx[key]) idx[key] = [];
    idx[key].push(k);
  });
  return idx;
}

/* ---------- gop vao du lieu dang co ---------- */
function sigItems(items) {
  return items.map(function (it) { return (it.barcode || '?') + 'x' + (it.qty || 0); }).join('|');
}

/* khop lai theo MA VACH chu khong theo vi tri */
export function remapItems(oldOrder, newOrder, w) {
  var nBase = oldOrder.items.length;
  var oldBase = w.items.slice(0, nBase);
  var subs = w.items.slice(nBase);            // dong thay the giu nguyen o cuoi
  var pool = {};
  oldBase.forEach(function (wi, ix) {
    var bc = String((oldOrder.items[ix] || {}).barcode || wi.barcode || '').toUpperCase();
    (pool[bc] = pool[bc] || []).push(wi);
  });
  var carried = 0;
  var base = newOrder.items.map(function (it) {
    var bc = String(it.barcode || '').toUpperCase();
    var src = (pool[bc] && pool[bc].length) ? pool[bc].shift() : null;
    if (src && src.picked) carried += src.picked;
    return { barcode: it.barcode, picked: src ? src.picked : 0, isSub: false, name: null };
  });
  var lost = 0;
  Object.keys(pool).forEach(function (k) { pool[k].forEach(function (wi) { lost += wi.picked || 0; }); });
  return { items: base.concat(subs), carried: carried, lost: lost };
}

/* Gop dataset moi (nds) vao ds/work dang co. SUA TAI CHO ds va work.
   - Don moi: them, pick/out = pending
   - Don cu: cap nhat thong tin san, GIU pick/out
   - Danh sach SP doi: anh xa lai theo ma vach, bao so luong da nhat bi mat
   - Don cu khong co trong file moi: giu nguyen (rp.gone chi de bao)
   - Don chuyen HUY ma da pick/out: liet ke rp.cancelled de chan giao
   Tra ve bao cao rp. */
export function mergeDataset(ds, work, nds) {
  var rp = { added: 0, statusChanged: 0, itemChanged: [], cancelled: [], lostQty: 0, gone: 0, files: 0 };
  rp.files = (nds.files || []).length;
  var seen = {};
  Object.keys(nds.orders).forEach(function (key) {
    seen[key] = 1;
    var no = nds.orders[key], oo = ds.orders[key], w = work.orders[key];
    if (!oo || !w) {
      ds.orders[key] = no; work.orders[key] = freshWork(no); rp.added++; return;
    }
    var touched = w.pickState !== 'pending' || w.outState !== 'pending';
    if (oo.statusGroup !== no.statusGroup) {
      rp.statusChanged++;
      if (no.statusGroup === 'HUY' && touched)
        rp.cancelled.push({
          id: no.orderId, chan: no.channel, tr: no.tracking,
          pick: w.pickState === 'done', out: w.outState === 'done'
        });
    }
    if (sigItems(oo.items) !== sigItems(no.items)) {
      var r = remapItems(oo, no, w);
      w.items = r.items; rp.lostQty += r.lost;
      if (touched) rp.itemChanged.push({ id: no.orderId, chan: no.channel, lost: r.lost });
    }
    ds.orders[key] = no;
  });
  Object.keys(ds.orders).forEach(function (k) { if (!seen[k]) rp.gone++; });

  /* gop danh sach file, tinh lai chi so */
  var fmap = {};
  (ds.files || []).concat(nds.files || []).forEach(function (f) { fmap[f.fileName || f.name || JSON.stringify(f)] = f; });
  ds.files = Object.keys(fmap).map(function (k) { return fmap[k]; });
  ds.duplicates = nds.duplicates; ds.unknownStatuses = nds.unknownStatuses; ds.noBarcode = nds.noBarcode;
  work.updatedAt = new Date().toISOString();
  (work.log = work.log || []).push({
    t: new Date().toISOString(), a: 'merge',
    d: { added: rp.added, statusChanged: rp.statusChanged, files: rp.files }
  });
  return rp;
}

/* ---------- tu don du lieu cu ----------
   Moc PURGE_DAYS ngay. SUA TAI CHO ds va work.
   - Da pick VA da out: tinh tu ngay out -> xoa
   - XONG/HUY chua ai thao tac: tinh tu ngay dat -> xoa
   - Con lai: KHONG BAO GIO tu xoa
   now: epoch ms (truyen vao de test), mac dinh Date.now() */
export function purgeOld(ds, work, days, now) {
  days = days || PURGE_DAYS;
  var cut = (now || Date.now()) - days * 864e5, n = 0, kept = 0;
  Object.keys(ds.orders).forEach(function (k) {
    var o = ds.orders[k], w = work.orders[k] || {};
    var drop = false;
    if (w.pickState === 'done' && w.outState === 'done') {
      var t = dayMs(w.outAt); drop = !isNaN(t) && t < cut;
    } else if ((o.statusGroup === 'XONG' || o.statusGroup === 'HUY') && w.pickState !== 'done' && w.outState !== 'done') {
      var t2 = dayMs(o.orderDate); drop = !isNaN(t2) && t2 < cut;
    }
    if (drop) { delete ds.orders[k]; delete work.orders[k]; n++; } else kept++;
  });
  if (n) {
    (work.log = work.log || []).push({ t: new Date().toISOString(), a: 'purge', d: { removed: n, kept: kept, days: days } });
  }
  return { removed: n, kept: kept };
}

/* ---------- chu ky don: de gom cac don giong het nhau ----------
   Chuoi 'BARCODE x qty' theo dung thu tu idx cua dong goc (bo dong thay the).
   Cung thu tu de idx khop nhau -> mot mang p_items dung chung cho ca nhom.
   items: dang DB (co isSub) hoac dang goc (khong co isSub). */
export function itemSignature(order) {
  return (order.items || []).filter(function (it) { return !it.isSub; })
    .map(function (it) { return (String(it.barcode || '').toUpperCase() || '?') + 'x' + (it.qty || 0); })
    .join('|');
}
